<template>
    <div class="bg-surface-50 dark:bg-surface-900 h-full flex flex-col overflow-hidden">
        <InputGroup>
            <IconField>
                <InputIcon class="pi pi-search z-50" />
                <InputText placeholder="Search testimonial" type="search" @input="debouncedInput" />
            </IconField>
            <InputGroupAddon>
                <Button
                    :loading="loading"
                    icon="pi pi-refresh"
                    severity="secondary"
                    v-tooltip="'Reload'"
                    @click="getTestimonials"
                />
            </InputGroupAddon>
        </InputGroup>

        <div class="mt-8 h-full overflow-auto">
            <div class="flex flex-col flex-1 overflow-auto gap-6">
                <div v-for="(item, index) of testimonialList" :key="index" class="flex flex-col gap-2">
                    <ReviewItem :testimonial="item" @refresh="getTestimonials" />

                    <Divider align="left" type="solid"> </Divider>
                </div>
            </div>
        </div>

        <Paginator
            v-if="testimonialList.length"
            :rows="pagination.rows"
            :totalRecords="pagination.totalRecords"
            :rowsPerPageOptions="[10, 20, 30]"
            @page="onPageChange"
        ></Paginator>
    </div>
</template>

<script setup>
import { ref, inject, onMounted } from "vue";
import { Divider, InputText, Button } from "primevue";
import Paginator from "primevue/paginator";
import { TestimonialStatusEnum } from "@/core/enums/TestimonialStatusEnum";
import ReviewItem from "./ReviewItem.vue";
import debounce from "lodash/debounce";
import IconField from "primevue/iconfield";
import InputIcon from "primevue/inputicon";
import InputGroup from "primevue/inputgroup";
import InputGroupAddon from "primevue/inputgroupaddon";

const testimonialService = inject("testimonialService");
const testimonialList = ref([]);
const loading = ref(false);
const pagination = ref({
    rows: 0,
    totalRecords: 0,
});

let currentPage = 1;
let perPage = 10;
let searchTerm = "";

onMounted(() => {
    getTestimonials();
});

const getTestimonials = async () => {
    try {
        loading.value = true;
        const response = await testimonialService.paginatedSearch(
            currentPage,
            perPage,
            [TestimonialStatusEnum.processing, TestimonialStatusEnum.review],
            searchTerm,
            "asc",
        );

        testimonialList.value = response.data;

        pagination.value = {
            rows: perPage,
            totalRecords: response.totalCount,
        };
    } finally {
        loading.value = false;
    }
};

const debouncedInput = debounce((event) => {
    searchTerm = event.target.value;
    currentPage = 1;
    getTestimonials();
}, 500);

const onPageChange = async (event) => {
    if (currentPage == event.page + 1 && perPage == event.rows) {
        return;
    }
    perPage = event.rows;
    currentPage = event.page + 1;
    await getTestimonials();
};
</script>

<style scoped></style>
